import { isAction } from './isAction'

export type ID = string | number | null
export type IDPayloadAction<P = void, T extends string = string> = {
  payload: P
  type: T
  id: ID
}

export const createIDAction = <P = void>(type: string) => {
  const actionCreator = (id: ID, payload: P): IDPayloadAction<P> => {
    return { type, payload, id }
  }

  actionCreator.toString = () => `${type}`

  actionCreator.type = type

  actionCreator.match = (action: unknown): action is IDPayloadAction =>
    isAction(action) && action.type === type

  return actionCreator
}
